import _ from 'lodash'

let updateTime = null
const ADDITIONAL_TITLE_PADDING_SIZE = 32

const parseNum = (num) => {
  let n = parseInt(num, 10)
  if (isNaN(n)) {
    return 0
  } else {
    return n
  }
}

function getAbsoluteHeight(el) {
  // Get the DOM Node if you pass in a string
  el = typeof el === 'string' ? document.querySelector(el) : el

  if (el) {
    let styles = window.getComputedStyle(el)
    let margin = parseNum(styles['marginTop']) + parseNum(styles['marginBottom'])

    if (el.dataset.ftRole === 'root') {
      let colsEl = el.querySelector('[data-ft-role="colsRoot"]')
      if (colsEl) {
        let colsHeight = getAbsoluteHeight(colsEl)
        return Math.max(Math.floor(el.offsetHeight + margin), colsHeight)
      }
    }

    return Math.floor(el.offsetHeight + margin)
  } else {
    return 0
  }
}

const marginStyleKeys = ['marginTop', 'marginBottom']
const paddingStyleKeys = ['paddingTop', 'paddingBottom']
const styleKeys = [...marginStyleKeys, ...paddingStyleKeys]

const getNodeChildHeight = (node) => {
  if (!node) {
    return 0
  }
  let height = 0
  _.each(node.childNodes, (child) => {
    height += child?.clientHeight ?? 0
    const styles = getComputedStyle(child)
    _.each(styleKeys, (key) => {
      const num = parseFloat(String(styles[key]).replace('px', ''))
      if (!isNaN(num)) {
        height += num
      }
    })
  })
  return height
}

const calcSurveyPanelOptimizedHeight = (node) => {
  if (!node) {
    return 0
  }
  let height = 0

  const nodeStyles = getComputedStyle(node)
  _.each(styleKeys, (key) => {
    const num = parseFloat(String(nodeStyles[key]).replace('px', ''))
    if (!isNaN(num)) {
      height += num
    }
  })
  const logoNode = node.getElementsByClassName('survey-logo')
  if (logoNode.length > 0) {
    height += getNodeChildHeight(logoNode[0])
  }

  const welcomePanel = node.getElementsByClassName('ft--theme--PageConditionalForm--welcome')
  if (welcomePanel.length > 0) {
    height += getNodeChildHeight(welcomePanel[0])
  }

  const finishPanel = node.getElementsByClassName('ft--theme--PageConditionalForm--finish')
  if (finishPanel.length > 0) {
    height += getNodeChildHeight(finishPanel[0])
  }

  const questionPanel = node.getElementsByClassName('ft--theme--PageConditionalForm--qRoot')
  if (questionPanel.length > 0) {
    const panel = questionPanel[0]
    height += getNodeChildHeight(panel)
  }
  return height
}

const getOpenModalDoms = () =>
  document.querySelectorAll('.ft--theme--Modal--bd.visible .ft--theme--Modal--inner > .ft--scroll--content')

export const sendLWCSizeToParent = (isFromGrid, isDocGen, callback) => {
  try {
    const modalDoms = getOpenModalDoms()

    if (!modalDoms.length) {
      clearTimeout(updateTime)
    }
    updateTime = setTimeout(function () {
      let url = String(location.href)
      if (url.indexOf('#') > -1) {
        url = url.split('#')[0]
      }
      url = url.split('?')
      let params = {}
      if (url[1]) {
        url = String(url[1]).split('&')
        _.each(url, function (row) {
          row = row.split('=')
          params[row[0]] = row[1]
        })
      }
      let strips = document.getElementsByClassName('ft--theme--Strip--root')
      let totalHeight = 0
      _.each(strips, function (strip) {
        if (strip) {
          totalHeight += getAbsoluteHeight(strip)
        }
      })
      if (strips.length > 0) {
        totalHeight += 10
      }
      let headers = document.getElementsByClassName('ft--theme--Header--root')
      let isFoundHeader = false
      _.each(headers, function (header) {
        if (header && header.clientHeight && !isFoundHeader) {
          totalHeight += header.clientHeight
          isFoundHeader = true
        }
      })
      let footers = document.getElementsByClassName('ft--theme--Footer--root')
      let isFoundFooter = false
      _.each(footers, function (footer) {
        if (footer && footer.clientHeight && !isFoundFooter) {
          totalHeight += footer.clientHeight
          isFoundFooter = true
        }
      })
      const footerSpacing = document.querySelector('.ft-footer-float-spacing')
      if (isFoundFooter && footerSpacing) {
        totalHeight += footerSpacing.clientHeight
      }

      let pageId
      if (window && window.__FT_PROJECT__API__ && window.__FT_PROJECT__API__.getPage) {
        pageId = window.__FT_PROJECT__API__.getPage()
      }
      let domClassName = ''
      let domHeight = 0
      if (['signin', 'login', 'profile', 'register'].includes(pageId)) {
        domClassName = 'login-signup-center-part'
        isFromGrid = false
        domHeight += 100
      } else if (['e_checkout', 'e_catalog', 'e_product', 'e_cart'].includes(pageId)) {
        domClassName = 'ft--ecom-layout'
        isFromGrid = false
      }

      let domElem
      if (domClassName) {
        domElem = document.getElementsByClassName(domClassName)
      }
      let docGenElems = document.querySelectorAll('.ft-docgen-wrap')
      if (docGenElems.length > 0) {
        isDocGen = true
        domElem = docGenElems
      }
      if (domElem && domElem[0] && domElem[0].clientHeight) {
        if (docGenElems.length > 0 || isDocGen) {
          domHeight += Math.max(domElem[0].clientHeight, 600)
        } else {
          domHeight += domElem[0].clientHeight
          totalHeight += domElem[0].clientHeight
        }
      } else if (isDocGen || docGenElems.length) {
        isDocGen = true
        domHeight += 600
      }
      let domElemHeader = document.getElementsByClassName('ft--theme--Header--root')
      if (domElemHeader && domElemHeader[0] && domElemHeader[0].clientHeight) {
        domHeight += domElemHeader[0].clientHeight
      }
      let domElemFooter = document.getElementsByClassName('ft--theme--Footer--root')
      if (domElemFooter && domElemFooter[0] && domElemFooter[0].clientHeight) {
        domHeight += domElemFooter[0].clientHeight
      }
      const domFooterSpacing = document.querySelector('.ft-footer-float-spacing')
      if (domElemFooter && domFooterSpacing) {
        domHeight += domFooterSpacing.clientHeight
      }
      let surveyRoot = document.querySelector('.ft--theme--PageConditionalForm--root')
      if (!domHeight && surveyRoot) {
        let activePanel = surveyRoot.querySelector('.ft--theme--PageConditionalForm--content[data-active="true"]')
        if (activePanel) {
          let panelHeight = calcSurveyPanelOptimizedHeight(activePanel)
          domHeight += panelHeight
        }
      }
      if (!domHeight && totalHeight <= 20) {
        domHeight = 600
      }
      if (!isFromGrid || !totalHeight || isDocGen) {
        let shift = 20
        if (window.isSyncLastDomHeight == domHeight + shift || window.isSyncLastDomHeight == domHeight) {
          shift = 0
        }
        if (domHeight + shift > totalHeight) {
          totalHeight = domHeight + shift
          window.isSyncLastDomHeight = totalHeight
        }
      }
      if (!totalHeight) {
        return false
      }

      try {
        const modalDoms = getOpenModalDoms()

        let maxHeight = totalHeight
        let isFixedSize = false
        let fixedSize = 0

        if (modalDoms.length) {
          modalDoms.forEach((modalDom) => {
            if (modalDom.classList.contains('ft--modal--fixed-size')) {
              isFixedSize = true
              const modalRootElement = modalDom.closest('.ft--theme--Modal--root')
              fixedSize = modalRootElement?.getBoundingClientRect?.()?.height
            }

            const size = modalDom?.getBoundingClientRect?.()
            if (!size?.height) return

            const heightAdjustment = modalDom.classList.contains('ft--modal--auto-resize')
              ? ADDITIONAL_TITLE_PADDING_SIZE
              : 0
            maxHeight = Math.max(isFixedSize ? fixedSize : size.height + heightAdjustment, maxHeight)
          })

          totalHeight = maxHeight
        }
      } catch (err) {
        console.error(err)
      }

      if (document.getElementById('forbidden-page-wrap')) {
        totalHeight = 500
      }
      let data = {
        action: 'FTResize',
        data: {
          height: totalHeight,
        },
      }
      if (params.auth) {
        data.auth = params.auth
      }
      try {
        let builderEls = document.querySelectorAll('.ft--project-toolbar, .ft--builder-panel-title')
        if (builderEls.length === 0 && typeof window !== 'undefined' && window.__FT_PROJECT__API__?.FTSyncState) {
          let isFirefox = navigator.userAgent.indexOf('Firefox') !== -1
          let appState = window.__FT_PROJECT__API__.FTSyncState()
          const device = appState.getIn(['state', 'device'])
          const isFluidWidth = _.get(window.__FT__APP__STATE?.project, ['Settings', 'responsiveAIConf', 'isFluidWidth'], false)
          const isAutoScale = _.get(window.__FT__APP__STATE?.project, ['Settings', 'responsiveAIConf', 'isAutoScale'], false)
          if (!isFirefox && !isFluidWidth && isAutoScale && device === 'Desktop') {
            let defVal = appState.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'width'], 1367)
            let pageWidth = appState.getIn(
              ['project', 'Settings', 'theme', 'lg', 'Page', appState.get('page'), 'width'],
              defVal
            )
            const windowWidth = window.document?.documentElement?.clientWidth || window.innerWidth
            const width = parseInt(pageWidth, 10)
            if (data.data.height) {
              let scale = parseFloat(windowWidth / width) - 0.05
              data.data.height = data.data.height * scale
              data.data.height = parseInt(data.data.height)
            }
          }
        }
      } catch (err) {
        console.error(err.stack)
      }
      window.parent.postMessage(JSON.stringify(data), '*')
      if (typeof callback === 'function') {
        callback(data)
      }
    }, 500)
  } catch (err) {}
}
